// Copyright (c) StrangeBee 2024

import ExternalLink from '@Atoms/ExternalLink/ExternalLink';
import { ICONS } from '@Constants/iconsApp';
import { classList } from '@Helpers/className';
import { THTooltip } from '@Molecules/THTooltip/THTooltip';
import React, { ReactElement } from 'react';
import { THInput, THInputProps } from '../THInput/THInput';

import './THInputLink.scss';

export const THInputLink = ({ containerClassname, ...props }: THInputProps): ReactElement => {
    const isActive = props.value && typeof props.value === 'string';
    const title = isActive ? props.value : null;
    return (
        <THTooltip trigger={['focus']} title={title} placement="topLeft">
            <THInput
                {...props}
                containerClassname={classList('th-input__link', containerClassname)}
                extraAction={
                    isActive ? (
                        <ExternalLink url={props.value as string}>
                            <ICONS.ExternalLink />
                        </ExternalLink>
                    ) : undefined
                }
            />
        </THTooltip>
    );
};
